import {
  ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterAdoptions from '../../components/FilterAdoptions'

function AdoptionsByRegion({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsByRegion,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatório de adoções por região"
        subtitle="Lista de adoções confirmadas por região dos adotantes"
        icon="fas fa-map-marker-alt"
        rightAction={() => <FilterAdoptions donors={data?.donors} />}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <table className="table table-hover text-small">
              <thead>
                <tr>
                  <th>Cidade</th>
                  <th>Bairro</th>
                  <th className="text-right" width="300px">
                    Quantidade de adoções
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((row) => (
                  <tr key={`${row?.city}-${row?.district}-${row?.total}`}>
                    <td>{row?.city || 'Não informado'}</td>
                    <td>{row?.district || 'Não informado'}</td>
                    <td className="text-right">{row?.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )}
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default AdoptionsByRegion
